import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

const routes = [

    {
        path: '/',
        name: 'Home',
        component: () => import('../view/result.vue')
    },

    {
        path: '/config',
        name: 'config',
        component: () => import('../view/config.vue')
    },

    {
        path: '/404',
        name: '404',
        component: () => import('../view/result.vue')
    },
    {
        redirect: '/result',
        path: '/:pathMatch(.*)',
    },
    {
        path: '/:catchAll(.*)', // 使用通配符来捕获所有未匹配的路径  
        component: () => import('../view/result.vue')
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
